import axios from "./productInstance";

const changeProductProfileState = async (productId: string, active: boolean) => {


    try {
        const response = await axios.post(`/products/${productId}/${active ? "activate-product-profile" : "deactivate-product-profile"}` );
        return response.data?.message ?? null;
    } catch (error: any) {
        console.error("Error change product profile state:", error?.response?.data || error.message);
        throw error?.response?.data?.error.replace(/_/g, " ") || new Error("Unknown error occurred while change product profile state");
    }


}

export default changeProductProfileState;